import React from "react";
import {FormattedMessage} from "react-intl";
import Icon from "../Utils/Icon";
import AccessControl from "../../hoc/AccessControl";
import classes from "../RegistryTable/styles.module.css";

function MenuItem({handleClickDetail, hasAccess, merchantUUID}) {
    return (
        <li
            className={hasAccess ? classes.MenuItem : `${classes.MenuItem} ${classes.MenuItemDisables}`}
            onClick={() => hasAccess && handleClickDetail()}
        >
            <Icon className={classes.MenuIcon} icon="eye" size="14px"/>
            <FormattedMessage id="RegistryList.menu.view" defaultMessage="Детальный просмотр"/>
        </li>
    );
}

export default AccessControl(MenuItem);



// WEBPACK FOOTER //
// ./src/Components/RegistryList/MenuItem.js